import { CheckCircle, Home, RotateCcw, Trophy } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DEMO_STEPS, useDemoSteps } from "../../components/demo/DemoNavigator";
import { useI18nStore } from "../../stores/i18nStore";

const DemoCompletePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18nStore();
  const steps = useDemoSteps();

  const restart = () => {
    sessionStorage.setItem("demo-mode", "true");
    navigate(DEMO_STEPS[0]?.path ?? "/demo");
  };

  const finish = () => {
    sessionStorage.removeItem("demo-mode");
    navigate("/dashboard");
  };

  return (
    <div className="max-w-2xl mx-auto pt-12 text-center space-y-8">
      <div className="flex justify-center">
        <div className="p-6 bg-yellow-100 rounded-full">
          <Trophy className="w-16 h-16 text-yellow-600" />
        </div>
      </div>

      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          {t.demoCompleteTitle}
        </h1>
        <p className="text-gray-600 text-lg">{t.demoCompleteDescription}</p>
      </div>

      {/* Summary */}
      <div className="bg-white border border-gray-200 rounded-xl p-6 text-left shadow-sm">
        <h3 className="font-semibold text-gray-900 mb-4">
          {t.demoCompletedScenarios}
        </h3>
        <div className="space-y-3">
          {steps.map((step) => {
            const StepIcon = step.icon;
            return (
              <div key={step.id} className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                <div className={`p-1.5 rounded-lg ${step.color} text-white`}>
                  <StepIcon className="w-4 h-4" />
                </div>
                <div>
                  <span className="font-medium text-gray-900">
                    {step.title}
                  </span>
                  <p className="text-xs text-gray-500 mt-0.5">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex gap-4 justify-center">
        <button
          onClick={restart}
          className="flex items-center gap-2 px-6 py-3 border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <RotateCcw className="w-4 h-4" />
          {t.demoRestart}
        </button>
        <button
          onClick={finish}
          className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition-colors"
        >
          <Home className="w-4 h-4" />
          {t.demoToDashboard}
        </button>
      </div>
    </div>
  );
};

export default DemoCompletePage;
